import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { cloneDeep } from 'lodash';
import { catchError, combineLatest, map, of, switchMap } from 'rxjs';
import { AuthActions } from '@components/auth/auth.actions';
import { reportActiveHealthGuidelineActions } from './health-guideline.actions';
import { ReportActiveHGService } from './health-guideline.service';

/**
 * Health guideline effects.
 */
@Injectable()
export class HealthGuidelineEffects extends ReportActiveHGService {
  private readonly actions = inject(Actions);

  readonly onAuthChange = createEffect(() => {
    return this.actions.pipe(
      ofType(AuthActions.logout, AuthActions.switchProfile),
      map(() => reportActiveHealthGuidelineActions.resetUserData())
    );
  });

  readonly onFetchGuideline = createEffect(() => {
    return this.actions.pipe(
      ofType(reportActiveHealthGuidelineActions.fetchGuideline),
      switchMap(() =>
        combineLatest([
          this.fetchGuideline({
            include: ['rpx-sport-guideline-summary']
          }),
          this.fetchGuidelineExercises({
            include: ['rpx-sport-guideline-exercise-insight']
          })
        ]).pipe(
          map(([guideline, exercises]) => {
            const response = guideline ? cloneDeep(guideline) : null;
            if (response) {
              response.sGuidelineExercise = Array.isArray(exercises)
                ? cloneDeep(exercises)
                : [];
            }
            return reportActiveHealthGuidelineActions.fetchGuidelineSuccess({
              guideline: response
            });
          }),
          catchError(() =>
            of(reportActiveHealthGuidelineActions.fetchGuidelineFailed())
          )
        )
      )
    );
  });
}
